export default __webpack_public_path__ + "static/multi-wave-bbc6f2d60bc3eac7810df75c2ede43a8.png";